import PRIVACY_POLICY_TEXT from '@/constants/privacyPolicy';
import { ShieldCheck } from '@phosphor-icons/react';

const renderMarkdown = (md) =>
  md.split('\n').map((line, i) => {
    if (line.startsWith('# ')) return <h1 key={i} className="text-2xl font-bold text-[#F8FAFC] mt-6 mb-3">{line.slice(2)}</h1>;
    if (line.startsWith('## ')) return <h2 key={i} className="text-lg font-semibold text-[#F59E0B] mt-5 mb-2">{line.slice(3)}</h2>;
    if (line.startsWith('- ')) return <li key={i} className="text-[#F8FAFC] ml-6 list-disc mb-1">{line.slice(2)}</li>;
    if (line.startsWith('*') && line.endsWith('*')) return <p key={i} className="text-[#94A3B8] italic border-l-2 border-[#2563EB] pl-3 my-3">{line.slice(1, -1)}</p>;
    if (line === '---') return <hr key={i} className="border-[#1E293B] my-4" />;
    if (!line.trim()) return <br key={i} />;
    return <p key={i} className="text-[#F8FAFC] leading-relaxed mb-2" dangerouslySetInnerHTML={{ __html: line.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>') }} />;
  });

const PrivacyPolicy = () => (
  <div className="min-h-screen bg-[#0F172A] py-8 px-4">
    <div className="max-w-3xl mx-auto bg-[#0F172A] border border-[#1E293B] rounded-lg p-6 sm:p-10">
      <div className="flex items-center gap-3 mb-6 pb-4 border-b border-[#1E293B]">
        <ShieldCheck size={32} weight="duotone" className="text-[#2563EB]" />
        <div>
          <h1 className="text-xl font-bold text-[#F8FAFC]">Gazelle Security SARLU</h1>
          <p className="text-xs text-[#94A3B8]">Politique de confidentialité — Version du 13/08/2026</p>
        </div>
      </div>
      <article data-testid="privacy-policy-content">{renderMarkdown(PRIVACY_POLICY_TEXT)}</article>
    </div>
  </div>
);

export default PrivacyPolicy;
